import React, {useEffect, useState} from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';

const MyMapComponent = (props) => {
    const mapState  = { center: [41.311155, 69.279700], zoom: 12 }; // Default center on Tashkent
    const [placemarkCoords, setPlacemarkCoords] = useState(mapState.center);

    // Handler for placemark drag
    const onPlacemarkDrag = (event) => {
        const newCoords = event.get('target').geometry.getCoordinates();
        setPlacemarkCoords(newCoords);

        props.setSendData({...props.sendData, latitude: newCoords[0]})
        props.setSendData({...props.sendData, longitude: newCoords[1]})
    };

    // Handler for map click
    const onMapClick = (event) => {
        const coords = event.get('coords');
        setPlacemarkCoords(coords);
        props.setlatitude(coords[0])
        props.setlongitude(coords[1])
    };
useEffect(()=>{
    if (props.selectpls > 0){
        setPlacemarkCoords([props.latitude, props.longitude])
    }
}, [])


    return (
     <div className="">

         <div className="d-flex mb-4">
             <div className="inputs-box w-100 mr-24">
                 <label className="font-family-medium">Широта (Latitude)</label>
                 <input
                     onChange={(e) => props.setlatitude(e.target.value)}
                     value={props.latitude}
                     type="text"/>
             </div>
             <div className="inputs-box w-100">
                 <label className="font-family-medium">Долгота (Longitude) </label>
                 <input
                     onChange={(e) => props.setlongitude(  e.target.value )}
                     value={props.longitude}
                     type="text"/>
             </div>
         </div>
         <YMaps>
             <div>
                 <Map defaultState= {mapState} width="100%" height="400px" onClick={onMapClick}>
                     <Placemark
                         geometry={placemarkCoords}
                         options={{ draggable: true }}
                         onDragEnd={onPlacemarkDrag}
                     />
                 </Map>
                 {/*<div className="text-white">Selected Location: {props?.sendData?.latitude + console.log(placemarkCoords)}*/}
                 {/*    /!*{placemarkCoords.join(', ')}*!/*/}
                 {/*</div>*/}
             </div>
         </YMaps>
     </div>
    );
};

export default MyMapComponent;
